<template>
  <div class="home">
    <div class="row">
      <div class="col-md-12">
        <!--begin::Portlet-->
        <div class="m-portlet">
          <div class="m-portlet__head">
            <div class="m-portlet__head-caption">
              <div class="m-portlet__head-title">
                <span class="m-portlet__head-icon m--hide">
                  <i class="la la-gear"></i>
                </span>
                <h3 class="m-portlet__head-text">Chat with Teacher</h3>
              </div>
            </div>
          </div>
          <div class="m-portlet__body">

            <div class="row">

              <div class="col-md-12">
                <div class="empty-data">
                  <img src="/media/icons/empty.png" />
                  <h2>No Records Available</h2>
                </div>
              </div>

            </div>

          </div>
        </div>
        <!--end::Portlet-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'chatwithteacher'
}
</script>

<style scoped>

</style>
